import { render } from "./OtherTop.vue?vue&type=template&id=209e00e7&scoped=true"
import script from "./OtherTop.vue?vue&type=script&lang=js"
export * from "./OtherTop.vue?vue&type=script&lang=js"

import "./OtherTop.vue?vue&type=style&index=0&id=209e00e7&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209e00e7"]])

export default __exports__